<form [formGroup]="searchForm" *ngIf="!showSearchCard && searchForm">
    <div class="ui-g ui-fluid search-toolbar-container">
        <p-accordion>
            <p-accordionTab [selected]="true">
                <p-header *ngIf="false">
                    {{ 'toolbar.filters' | translate }}
                </p-header>

                <div class="ui-g-12 search-toolbar-box-container" style="padding-bottom: 0;">
                    <!-- Divisione e Negozio -->
                    <div *ngIf="!customerMgPermission"
                        class="ui-g-3 card card-w-title search-toolbar-box search-toolbar-box-analysis"
                        style="border-right: #edf0f5 2px solid;">
                        <div class="row ui-g-12">
                            <i class="fa fw-user"></i>
                            <span>{{ 'loyalty.account_balance_filter_store' | translate}}</span>
                        </div>
                        <div class="row ui-g-12">
                            <div class="ui-g-12">{{ 'common.division_sales_network' | translate}}</div>
                            <div class="ui-g-12 search-toolbar-input">
                                <p-dropdown [options]="divisionSaleNetworkItems"
                                    (onChange)="onDivisionSalesNetworkChange($event)" [style]="{ 'width': '100%'}"
                                    formControlName="dsn">
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="row ui-g-12">
                            <div class="ui-g-12">{{ 'common.store_name' | translate}}</div>

                            <div class="row ui-g-12" style="visibility: hidden; ">
                                <label>&nbsp;</label>
                            </div>
                            <div class="ui-g-12 search-toolbar-input">
                                <p-multiSelect [options]="storeItems" [style]="{ 'width': '100%'}"
                                    formControlName="store" defaultLabel="{{'common.all' | translate}}">
                                </p-multiSelect>
                            </div>
                        </div>
                    </div>
                    <!-- Carta ed Accumulatore -->
                    <!-- TODO: KS-6867: scambiare carta con Cliente -->
                    <div [ngClass]="customerMgPermission ? 'ui-g-6' : 'ui-g-3'"
                        class="card card-w-title search-toolbar-box search-toolbar-box-analysis"
                        style="border-right: #edf0f5 2px solid;">
                        <div class="row ui-g-12">
                            <i class="fa fw-user"></i>
                            <span>{{ 'loyalty.account_balance_filter_customer' | translate}}</span>
                        </div>
                        <div class="row ui-g-12">
                            <div class="ui-g-12">
                                <label for="customer" class="required">{{ 'common.customer' | translate}}</label>
                            </div>
                            <div class="ui-g-12 search-toolbar-input">
                                <input [style]="{ width: '80% !important' }" name="customer" required type="text"
                                    disabled pInputText formControlName="customer" />
                                <p-button pTooltip="{{ 'common.select' | translate }}"
                                    icon="fa fas fa-arrow-circle-right" styleClass="ui-button-info"
                                    (onClick)="onOpenSelectCard()"></p-button>
                            </div>
                        </div>

                        <!-- TODO aggiungere filro per carte blacklist attive -->
                        <div class="row ui-g-12">
                            <div class="ui-g-12">
                                <label for="card" [ngClass]="{ 'required': customerMgPermission }">{{ 'common.acm' |
                                    translate }}</label>
                            </div>
                            <div class="ui-g-12">
                                <p-checkbox binary="true" [(ngModel)]="showExpiredAcm" inputId="expiredCheckbox"
                                    (onChange)="onExpiredCheckboxChange($event)">
                                </p-checkbox>
                                <label for="expiredCheckbox" style="margin-left: 0.5rem;">{{ 'common.evenExpired' |
                                    translate }}</label>
                            </div>


                            <div class="ui-g-12 search-toolbar-input">
                                <p-dropdown [options]="visibleAcmItems" [disabled]="showAcmSelecterd"
                                    formControlName="acm" [style]="{ 'width': '100%' }">
                                </p-dropdown>
                            </div>


                        </div>


                        <!-- Aggiunto per fare in modo che esista -->
                        <input type="hidden" formControlName="customer_id">
                    </div>
                    <!-- Periodo -->
                    <div [ngClass]="customerMgPermission ? 'ui-g-6' : 'ui-g-3'"
                        class="card card-w-title search-toolbar-box search-toolbar-box-analysis"
                        style="border-right: #edf0f5 2px solid;">
                        <div class="row ui-g-12">
                            <i class="fa fw-user"></i>
                            <span>{{ 'loyalty.account_balance_filter_dates' | translate}}</span>
                        </div>
                        <div class="row ui-g-12">
                            <div class="ui-g-12">
                                <label for="date_start">{{ 'common.date_start' | translate}}</label>
                            </div>
                            <div class="ui-g-12 search-toolbar-input">
                                <app-kv-calendar #dateStartField [inputName]="'date_start'" [formData]="searchForm"
                                    [maxDate]="dateStartMax" [startDateSelector]="true" [endDateInputName]="'date_end'"
                                    [endDateCalendar]="dateEndField"></app-kv-calendar>
                            </div>
                            <div class="ui-g-12 search-toolbar-input" *ngIf="dateStartIssue">
                                <span class="input-error-notification">{{ 'common.startDateLimit' | translate }}</span>
                            </div>
                        </div>
                        <div class="row ui-g-12">
                            <div class="ui-g-12">
                                <label for="date_end">{{ 'common.date_end' | translate}}</label>
                            </div>

                            <div class="row ui-g-12" style="visibility: hidden; ">
                                <label>&nbsp;</label>
                            </div>


                            <div class="ui-g-12 search-toolbar-input">
                                <app-kv-calendar #dateEndField [inputName]="'date_end'" [formData]="searchForm"
                                    [minDate]="dateEndMin" [endDateSelector]="true" [startDateInputName]="'date_start'"
                                    [startDateCalendar]="dateStartField"></app-kv-calendar>
                            </div>
                            <div class="ui-g-12 search-toolbar-input" *ngIf="dateEndIssue">
                                <span class="input-error-notification">{{ 'common.endDateLimit' | translate }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- Causale -->
                    <div *ngIf="!customerMgPermission"
                        class="ui-g-3 card card-w-title search-toolbar-box search-toolbar-box-analysis"
                        style="border-right: #edf0f5 2px solid;">
                        <div class="row ui-g-12">
                            <i class="fa fw-user"></i>
                            <span>{{ 'loyalty.account_balance_filter_reason' | translate}}</span>
                        </div>
                        <div class="row ui-g-12">
                            <div class="ui-g-12">{{ 'common.reason' | translate}}</div>
                            <div class="ui-g-12 search-toolbar-input">
                                <p-multiSelect [options]="reasonItems" formControlName="reason"
                                    [defaultLabel]="'common.choose' | translate">
                                </p-multiSelect>
                            </div>
                        </div>
                        <div class="row ui-g-12">
                            <div class="ui-g-12">{{ 'common.exclude_selected' | translate}}</div>


                            <div class="row ui-g-12" style="visibility: hidden; ">
                                <label>&nbsp;</label>
                            </div>
                            <div class="ui-g-12 search-toolbar-input">
                                <p-checkbox [label]="'loyalty.exclude_selected_reason' | translate" binary="true"
                                    formControlName="exclude_reason"></p-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
    <div class="ui-g-12">
        <div class="ui-g-3"></div>
        <div class="ui-g-3">
            <button pButton class="k-generic-btn" style="width: 100% !important;" [label]="'common.reset' | translate"
                (click)="resetFilters()">
            </button>
        </div>
        <div class="ui-g-3">
            <button [disabled]="!searchForm.valid" pButton type="submit" class="k-generic-btn"
                style="width: 100% !important;" icon="fa fa-search" iconPos="left" [label]="'common.apply' | translate"
                (click)="search($event)">
            </button>
        </div>
        <div class="ui-g-3"></div>
    </div>
</form>

<p-dialog *ngIf="showSearchCard" [(visible)]="showSearchCard" header="{{ 'card.select_card' | translate }}"
    [responsive]="true" showEffect="fade" [modal]="true">
    <app-card-selection-table (onCardSelect)="onCardSelect($event)"></app-card-selection-table>
</p-dialog>


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-account-balance/loyalty-account-balance-filter.component.html